var lazyScroll = {

	promosBuild: function(){
		var $lazyLoadingItem = $('.lazy-loading-item');

		if($lazyLoadingItem.length > 0){
			$lazyLoadingItem.each(function(){
				var $this = $(this);
				lazyScroll.scrollInit($this);

				if(lazyScroll.isScrolledIntoView($this) === true){
					lazyScroll.bgPromoInit($this.find('.module-image'));
				}
			});
		}
	},

	scrollInit: function($t){
		$(window).on('scroll', function(){
			var thisToF = lazyScroll.isScrolledIntoView($t),
			$thisModuleImage = $t.find('.module-image');
			if($thisModuleImage.hasClass('bg-done') === false){
				if(thisToF === true){
					lazyScroll.bgPromoInit($thisModuleImage);
				}
			}
		});
	},

	bgPromoInit: function($thisModuleImage){
		var thisImage = $thisModuleImage.attr('data-largeLazyPromo');

		if (thisImage.length > 0){
			$thisModuleImage.css('background-image', 'url(' + thisImage + ')');
			$thisModuleImage.addClass('bg-done');
		}
	},

	isScrolledIntoView: function(elem){
		var docViewTop = $(window).scrollTop(),
    		docViewBottom = docViewTop + $(window).height(),
			elemTop = $(elem).offset().top,
			elemImg = $(elem).find('.module-image'),
    		elemBottom = elemTop,
			elemImgBottom = elemTop + elemImg.height(),
			elemState = (elemBottom <= docViewBottom) && (elemTop >= docViewTop),
			elemStateImg = (elemImgBottom <= docViewBottom) && (elemImgBottom >= docViewTop);

		if(elemState === true){
			return true;
		} else if (elemState === false){
			if(elemStateImg === true){
				return true;
			} else {
				return false;
			}
		}
	},

	widgetsImg: function(elem) {
		$(elem).find('[data-bg-img-src]').each(function(){
			var _this = $(this);
			var src = _this.attr('data-bg-img-src');
			_this.css('background-image', 'url(' + src + ')');
			_this.removeAttr('data-bg-img-src');
		});
	},

	widgetsLoad: function() {
		$(window).on('resize scroll', function() {
			if ($('[data-bg-img-src]').length) {
				$('.widget-slot').each(function(){
					if (lazyScroll.elementIsInView(this)) {
						lazyScroll.widgetsImg(this);
					}
				});
			}
		});
	},

	elementIsInView: function(elem) {
	    var elementTop = $(elem).offset().top;
	    var elementBottom = elementTop + $(elem).outerHeight();

	    var viewportTop = $(window).scrollTop();
	    var viewportBottom = viewportTop + $(window).height();

	    return elementBottom > viewportTop && elementTop < viewportBottom;
	},

	init: function() {
		if($(window).width() > 1023){
			lazyScroll.promosBuild();
		}
		$(window).on('resize', function(){
			if($(window).width() > 1023){
				lazyScroll.promosBuild();
			}
		});

		if ($('[data-bg-img-src]').length) {
			lazyScroll.widgetsLoad();
		}
	}
};
